/*
  Regra de força de senha compartilhada pelos formulários de troca e redefinição.
  Espelho de backend/src/utils/senha.js — mantenha os dois arquivos em sincronia
  quando a política mudar.
*/
export const SENHA_REGEX =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]).{8,}$/;

export const SENHA_REGRA_MENSAGEM =
  "A nova senha deve ter no mínimo 8 caracteres, incluindo letra maiúscula, minúscula e um caractere especial";

export function validarSenha(senha) {
  return SENHA_REGEX.test(senha);
}
